export var hardBreak = function (_node) {
    return '\n';
};
//# sourceMappingURL=hard-break.js.map